import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/site";

export default function CategoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="主题分类"
          title="按类型找瓜，比翻聊天记录快得多"
          description="不同类别的传闻，证据形态完全不同。分类之下，我们用了不同的核对重点。"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/gossip?cat=${encodeURIComponent(cat.key)}`}
              className="group flex items-start gap-4 border border-background-200 rounded-card bg-background-50 p-5 hover:border-primary-300 transition-colors"
            >
              <span className="shrink-0 w-12 h-12 flex items-center justify-center rounded-control bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {cat.name}
                  </span>
                  <span className="font-mono-num text-[11px] text-foreground-400">
                    {cat.count}
                  </span>
                </span>
                <span className="mt-1.5 block text-xs text-foreground-600 leading-relaxed">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600 font-medium">
                  进入分类
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}